<core-generic-table [dataInput]="clients()" [endpoint]="endpoint" [listTitle]="'clients.title' | translate"
  [columns]="columns" [modalTabs]="modalFields()" [actions]="actions" [customActions]="customActions"
  [globalActions]="globalActions" [showFilter]="false" [showSelection]="false" [showActions]="true"
  [showCreateButton]="true" [enablePagination]="true" [modelFactory]="clientsModelFactory" [sortConfig]="sortConfig()"
  class="o-layout__section"></core-generic-table>